import React from "react";
import { useAppSelector } from "@/hooks";

import { Box, Container } from "@/components/Atoms/Box";
import theme from "@/foundation/Theme";
import { Typography } from "@/foundation/Typography/V2";

import { StyledDetailsSection } from "./style";

function DetailsSection() {
  const { jobData } = useAppSelector((state) => state.careersPage);

  const {
    description,
    about,
    skills,
    responsibilities,
    immediate,
    preferred_location: preferredLocation,
  } = jobData || {};

  const formattedSkills = skills?.filter((skill) => !!skill);
  const formattedResponsibilities = responsibilities?.filter(
    (responsibility) => !!responsibility
  );

  return (
    <StyledDetailsSection>
      <Container className="container">
        <Box className="details-section">
          {description && (
            <Box className="summary">
              <Typography
                variant="paragraph2"
                color={theme.colorsV2.gray.shade_700}
              >
                {description}
              </Typography>
            </Box>
          )}
          {about && (
            <Box className="about">
              <Typography
                variant="heading5"
                className="title"
                color={theme.colors.black}
              >
                About the Role
              </Typography>
              <Typography variant="paragraph2" color={theme.colors.black}>
                {about}
              </Typography>
            </Box>
          )}
          {formattedSkills?.length > 0 && (
            <Box className="skills">
              <Typography
                variant="heading5"
                className="title"
                color={theme.colors.black}
              >
                Skills & Competencies
              </Typography>
              {formattedSkills?.map((skill) => (
                <Typography
                  className="skill"
                  variant="paragraph2"
                  color={theme.colors.black}
                >
                  {skill}
                </Typography>
              ))}
            </Box>
          )}
          {formattedResponsibilities?.length > 0 && (
            <Box className="responsibilities">
              <Typography
                variant="heading5"
                className="title"
                color={theme.colors.black}
              >
                Responsibilities
              </Typography>
              {formattedResponsibilities?.map((responsibility) => (
                <Typography
                  className="responsibility"
                  variant="paragraph2"
                  color={theme.colors.black}
                >
                  {responsibility}
                </Typography>
              ))}
            </Box>
          )}
          <Box className="misc">
            {immediate && (
              <Typography
                variant="label2"
                fontFamily="var(--man-700)"
                color={theme.colors.black}
              >
                Joining - Immediate
              </Typography>
            )}
            {preferredLocation && (
              <Typography
                variant="label2"
                fontFamily="var(--man-700)"
                color={theme.colors.black}
              >
                Location - {preferredLocation}
              </Typography>
            )}
          </Box>
        </Box>
      </Container>
    </StyledDetailsSection>
  );
}

export default DetailsSection;
